import React from "react";
import {
  Card,
  CardContent,
  Box,
  Typography,
  Chip,
  Button,
  Stack,
} from "@mui/material";

const ApprovalCard = ({ workOrder, onApprove, onReject, onClick }) => {
  return (
    <Card
      onClick={() => onClick?.(workOrder.id)}
      sx={{
        mb: 1.5,
        background: "#FFFFFF",
        border: "1px solid #E2E8F0",
        borderRadius: "12px",
        boxShadow: "none",
        boxSizing: "border-box",
        cursor: onClick ? "pointer" : "default",
      }}
    >
      <CardContent
        sx={{
          p: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: 2,
        }}
      >
        {/* Work Order ID and Title - Horizontal */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 1.2,
            flexWrap: "wrap",
          }}
        >
          <Chip
            label={workOrder.id}
            sx={{
              bgcolor: "#45556C",
              color: "#fff",
              fontWeight: 700,
              fontSize: "12px",
              lineHeight: "24px",
              borderRadius: "8px",
              fontFamily:
                'Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
            }}
          />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              lineHeight: "24px",
              color: "#020618",
            }}
          >
            {workOrder.title}
          </Typography>
        </Box>

        {/* Details Grid */}
        <Stack
          direction="row"
          spacing={4}
          sx={{
            width: "100%",
          }}
        >
          {["Due", "Cost", "Parts"].map((label, index) => {
            const value =
              label === "Due"
                ? workOrder.dueDate
                : label === "Cost"
                  ? `$${workOrder.cost.toLocaleString()}`
                  : `${workOrder.parts} items`;

            return (
              <Box
                key={label}
                sx={{
                  flex: 1, // 🔥 makes them evenly spread
                  minWidth: 0,
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    color: "#020618",
                    fontWeight: 600,
                    fontSize: "14px",
                    lineHeight: "20px",
                    display: "block",
                    mb: 0.5,
                  }}
                >
                  {label}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#020618",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "20px",
                  }}
                >
                  {value}
                </Typography>
              </Box>
            );
          })}
        </Stack>

        {/* Action Buttons */}
        <Stack
          direction="row"
          spacing={2}
          sx={{
            width: "100%",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              flex: 1, // 🔥 evenly split space
              height: 39,
              background: "#F0FDF4",
              border: "1px solid #008236",
              color: "#008236",
              boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
              borderRadius: "8px",
              fontWeight: 700,
              fontSize: { xs: "0.875rem", md: "0.9375rem" },
              textTransform: "none",
              "&:hover": {
                border: "1px solid #008236",
                background: "#F0FDF4",
              },
            }}
            onClick={(e) => {
              e.stopPropagation();
              onApprove(workOrder.id);
            }}
          >
            Approve
          </Button>

          <Button
            variant="outlined"
            sx={{
              flex: 1, // 🔥 evenly split space
              height: 39,
              background: "#FEF2F2",
              border: "1px solid #C10007",
              color: "#C10007",
              boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
              borderRadius: "8px",
              fontWeight: 700,
              fontSize: { xs: "0.875rem", md: "0.9375rem" },
              textTransform: "none",
              "&:hover": {
                border: "1px solid #C10007",
                background: "#FEF2F2",
              },
            }}
            onClick={(e) => {
              e.stopPropagation();
              onReject(workOrder.id);
            }}
          >
            Reject
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ApprovalCard;
